import { render } from "./ContactVue.vue?vue&type=template&id=85923fc0"
import script from "./ContactVue.vue?vue&type=script&lang=js"
export * from "./ContactVue.vue?vue&type=script&lang=js"

import "./ContactVue.vue?vue&type=style&index=0&id=85923fc0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__